import { getOptimizely } from ".";
import { OptimizelyPushEvent } from "./types";

export function pushOptimizelyEvent(event?: OptimizelyPushEvent) {
  event && getOptimizely().push(event);
}
